module.exports = __webpack_public_path__ + "assets/img/1-1.1b97b4f6.svg";